import {
  EmptyStateIcon,
  ExtendedTypography,
} from '@issuemanager/apps/client/components';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Link as MUILink, Stack } from '@mui/material';
import { JSX } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  onAddRelationship: () => void;
};

export function RelationshipsEmptyState({
  onAddRelationship,
}: Props): JSX.Element {
  const { t } = useTranslation(['issue']);
  const semantic = useAtlasSemanticThemeTokens();

  return (
    <Stack
      spacing={4}
      justifyContent='center'
      alignItems='center'
      padding={8}
      data-testid='relationships-empty-state'
    >
      <EmptyStateIcon />
      <Stack spacing={1.5} alignItems='center'>
        <ExtendedTypography fontWeight='bold'>
          {t('issue:relationships.empty.title')}
        </ExtendedTypography>
        <ExtendedTypography
          variant='body2'
          color={semantic.color.text.muted.value}
          display='flex'
          alignItems='center'
          columnGap={1}
        >
          <Trans
            t={t}
            i18nKey={t('issue:relationships.empty.description')}
            components={{
              addBtn: (
                <MUILink
                  component='button'
                  onClick={onAddRelationship}
                  data-testid='add-relationship-btn'
                  sx={{ pointerEvents: 'auto', verticalAlign: 'bottom' }}
                />
              ),
            }}
          />
        </ExtendedTypography>
      </Stack>
    </Stack>
  );
}
